import _ from 'lodash';
import { getMetaKey } from '../../components/Availability/common';
import { getMonthName } from '../../components/Availability/DeliveryOptions/utils';
import constants from '../../config/constants';
import { capitalizeString } from '../jsUtils';

const getTextsHomeDelivery = ({ arrivesTodayOrTomorrow, isFreeShippingApplicable, date, month, price, type }) => {
  if (arrivesTodayOrTomorrow && isFreeShippingApplicable) {
    const [labelType, labelDate] = type.split(' ');
    return {
      greenText: `${labelType} gratis ${labelDate}`,
      normalText: ``,
    };
  }
  if (!arrivesTodayOrTomorrow && isFreeShippingApplicable) {
    return {
      greenText: `Llega gratis`,
      normalText: `el ${date} de ${getMonthName(month)}`,
    };
  }
  if (arrivesTodayOrTomorrow) {
    return {
      greenText: `${type}`,
      normalText: `por ${price}`,
    };
  }
  if (!arrivesTodayOrTomorrow) {
    return {
      greenText: ``,
      normalText: `Llega el ${date} de ${getMonthName(month)} por ${price}`,
    };
  }
  return {
    greenText: ``,
    normalText: ``,
  };
};

const getTextsPickupInStore = ({ isFreeShippingApplicable, price = '', type, storeName, arrivesTodayOrTomorrow }) => {
  const [, labelDate] = type.split(' ');
  const regex = /(\d{2}\/\d{2})/;
  const dateMatch = type.match(regex);
  const formattedDate = dateMatch ? dateMatch[0] : '';

  const [day, monthNum] = formattedDate.split('/');
  const monthName = monthNum ? getMonthName(monthNum) : '';
  const displayDate = monthName ? `${day} de ${monthName}` : formattedDate;

  if (isFreeShippingApplicable || price.toLowerCase().includes('gratis')) {
    if (arrivesTodayOrTomorrow) {
      return {
        greenText: `Retira gratis ${labelDate}`,
        storeName,
      };
    }
    if (formattedDate) {
      return {
        greenText: `Retira gratis`,
        normalText: `el ${displayDate}`,
        storeName,
      };
    }
  }

  if (arrivesTodayOrTomorrow) {
    return {
      greenText: `Retira ${labelDate}`,
      normalText: `por ${price}`,
    };
  }
  if (formattedDate) {
    return {
      greenText: ``,
      normalText: `Retira el ${displayDate} por ${price}`,
    };
  }

  return {
    greenText: ``,
    normalText: ``,
  };
};

const getTextStockinStore = () => {
  return {
    normalText: `Disponible en tienda`,
  };
};

const getTexts = (props) => {
  const { shippingOptionType } = props;
  if (shippingOptionType === 'PickupInStore') {
    return getTextsPickupInStore(props);
  }
  if (shippingOptionType === 'StockInStore') {
    return getTextStockinStore(props);
  }
  return getTextsHomeDelivery(props);
};

const getDefaultLabels = () => ({
  HOME_DELI_OUTOFSTOCK: 'No disponible para entrega a domicilio',
  PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
  STOCK_IN_STORE_OUTOFSTOCK: 'No disponible en tienda',
});

/**
 * @param {object} stateOfStock - Availability information
 * @param {object} labels - Translation labels
 * @param {string} outOfStock - Key for out of stock text
 * @param {object} selectedDeliveryOption - Delivery data selected from useDeliveryDataPersistence hook
 * @param {string} shippingOptionType - Delivery type ('HomeDelivery', 'PickupInStore', 'StockInStore')
 * @returns {object|null} Generated text data or null if no data available
 */

export const generateDeliveryText = (value, stateOfStock, labels, shippingOptionType) => {
  let labelsLocal = labels;
  if (!value || _.isEmpty(value)) {
    return null;
  }

  if (!stateOfStock || _.isEmpty(stateOfStock)) {
    // Logger.error('generateDeliveryText - stateOfStock is required');
    return null;
  }

  if (!shippingOptionType || _.isEmpty(shippingOptionType)) {
    // Logger.error('generateDeliveryText - shippingOptionType is required');
    return null;
  }

  const validShippingTypes = [
    constants.AVAILABILITY_HOMEDELIVERY,
    constants.AVAILABILITY_PICKUPINSTORE,
    constants.AVAILABILITY_STOCKINSTORE,
  ];

  if (!validShippingTypes.includes(shippingOptionType)) {
    // Logger.error(`generateDeliveryText - shippingOptionType must be one of: ${validShippingTypes.join(', ')}`);
    return null;
  }

  if (!labels || _.isEmpty(labels)) {
    // Logger.error('generateDeliveryText - Labels object is required');
    const defaultLabels = getDefaultLabels();
    labelsLocal = defaultLabels;
  }

  const { labelsKey } = getMetaKey(shippingOptionType);
  const { outOfStock } = labelsKey;

  const {
    type = '',
    date = '',
    month = '',
    price = '',
    isError = false,
    locationName = '',
    storeName = '',
    isFreeShippingApplicable = false,
    parentStateName = '',
    textUnits = '',
    classUnits = '',
    operatorIcon = '',
  } = value;

  const isOutOfStock = stateOfStock === constants.AVAILABILITY_OUTOFSTOCK;
  const isStockInStore = shippingOptionType === constants.AVAILABILITY_STOCKINSTORE;
  const isHomeDelivery = shippingOptionType === constants.AVAILABILITY_HOMEDELIVERY;
  if (isError || isOutOfStock) {
    const deliverOptionText = labelsLocal[outOfStock];
    const capitalizeLocation = locationName ? capitalizeString(locationName) : '';
    return {
      isError: true,
      deliverOptionText,
      location: `${capitalizeLocation}, ${capitalizeString(parentStateName)}`,
    };
  }

  const arrivesTodayOrTomorrow = /hoy|mañana/.test(type);

  const { greenText, normalText } = getTexts({
    isFreeShippingApplicable,
    date,
    month,
    price,
    type,
    locationName,
    storeName,
    arrivesTodayOrTomorrow,
    shippingOptionType,
  });

  return {
    isError: false,
    greenText,
    normalText,
    isHomeDelivery,
    isStockInStore,
    locationName: capitalizeString(locationName),
    parentStateName: capitalizeString(parentStateName),
    storeName: capitalizeString(storeName),
    textUnits,
    classUnits,
    operatorIcon,
  };
};
